<template lang="html">
  <span class="lgrm-range-slider" :class="{ disabled }">
    <drag-helper
      v-bind:disabled="disabled"
      @dragstart="dragStart"
      @drag="drag"
      @dragend="dragEnd">
      <span ref="inner" class="range-slider-inner">
        <input class="range-slider-hidden" type="text" :name="name" :value="actualValue" :disabled="disabled">
        <span ref="sliderRail" class="range-slider-rail"></span>
        <!-- <span class="range-slider-fill" :style="{ width: valuePercent + '%' }"></span> -->
        <span v-if="mountComplete" class="range-slider-knob" ref="knob" :style="{ left: valuePercent + '%', borderColor: knobBorderColor }">
          <slot name="knob"></slot>
          <div class='knob-value'> {{ actualValue }}</div>
        </span>
      </span>
    </drag-helper>
  </span>
</template>

<script>
// @flow
// for color http://jsfiddle.net/vksn3yLL/
import DragHelper from './DragHelper'
import { round } from './utils'
import { hexToRgb } from '../../utils.js'
import each from 'lodash/each'
export default {
    props: {
        name: String,
        value: [String, Number],
        disabled: {
            type: Boolean,
            default: false
        },
        min: {
            type: [String, Number],
            default: 0
        },
        max: {
            type: [String, Number],
            default: 10
        },
        step: {
            type: [String, Number],
            default: 1
        }
    },
    data() {

        return {
            actualValue: null,
            dragStartValue: null,
            mountComplete: false,
            gradients: [
                [
                    0,
                    hexToRgb('#b94a48')
                ],[
                    60,
                     hexToRgb('#b94a48')
                ],
                [
                    80,
                    hexToRgb('#f1c40f')
                ],
                [
                    100,
                    hexToRgb('#4bc67d')
                ],
            ]
        };
    },
    created() {
        console.log(this.gradients)
        const { _min: min, _max: max } = this;
        let defaultValue = Number(this.value);
        if (this.value == null || isNaN(defaultValue)) {
            if (min > max) {
                defaultValue = min;
            }
            else {
                defaultValue = (min + max) / 2;
            }
        }
        this.actualValue = this.round(defaultValue);
    },
    mounted: function() {
        this.mountComplete = true
    },
    computed: {
        _min() {
            return Number(this.min);
        },
        _max() {
            return Number(this.max);
        },
        _step() {
            return Number(this.step);
        },
        valuePercent() {
            return (this.actualValue - this._min) / (this._max - this._min) * 100;
        },
        knobBorderColor() {
            
            const vm = this
            var colorRange = []
            each(vm.gradients, function(value, index) {
                if(index === 0){
                    return [0,0]
                }
                if(vm.valuePercent<=value[0]) {
                    colorRange = [index-1,index]
                    return false;
                }
            });
            console.log(colorRange, vm.valuePercent)
            
            //Get the two closest colors
            var firstcolor = vm.gradients[colorRange[0]][1];
            var secondcolor = vm.gradients[colorRange[1]][1];
            
            //Calculate ratio between the two closest colors
            var firstcolor_x = vm.sliderWidth()*(vm.gradients[colorRange[0]][0]/100);
            var secondcolor_x = vm.sliderWidth()*(vm.gradients[colorRange[1]][0]/100)-firstcolor_x;
            var slider_x = vm.sliderWidth()*(vm.valuePercent/100)-firstcolor_x;
            var ratio = slider_x/secondcolor_x
            
            //Get the color with pickHex(thx, less.js's mix function!)
            var result = vm.pickHex( secondcolor,firstcolor, ratio );
            return 'rgb('+result.join()+')'
            
        },
        
    },
    watch: {
        value(newValue) {
            const value = Number(newValue);
            if (newValue != null && !isNaN(value)) {
                this.actualValue = this.round(value);
            }
        },
        min() {
            this.actualValue = this.round(this.actualValue);
        },
        max() {
            this.actualValue = this.round(this.actualValue);
        }
    },
    methods: {
        dragStart(event, offset) {
            this.dragStartValue = this.actualValue;
            if (event.target === this.$refs.knob) {
                return;
            }
            // If the click is out of knob, move it to mouse position
            this.drag(event, offset);
        },
        drag(event, offset) {
            const { offsetWidth } = this.$refs.inner;
            this.actualValue = this.round(this.valueFromBounds(offset.left, offsetWidth));
            this.emitInput(this.actualValue);
        },
        dragEnd(event, offset) {
            const { offsetWidth } = this.$refs.inner;
            this.actualValue = this.round(this.valueFromBounds(offset.left, offsetWidth));
            if (this.dragStartValue !== this.actualValue) {
                this.emitChange(this.actualValue);
            }
        },
        emitInput(value) {
            this.$emit('input', value);
        },
        emitChange(value) {
            this.$emit('change', value);
        },
        valueFromBounds(point, width) {
            return (point / width) * (this._max - this._min) + this._min;
        },
        round(value) {
            return round(value, this._min, this._max, this._step);
        },
        pickHex(color1, color2, weight) {
            var p = weight;
            var w = p * 2 - 1;
            var w1 = (w/1+1) / 2;
            var w2 = 1 - w1;
            var rgb = [Math.round(color1[0] * w1 + color2[0] * w2),
                Math.round(color1[1] * w1 + color2[1] * w2),
                Math.round(color1[2] * w1 + color2[2] * w2)];
            return rgb;
        },
        sliderWidth(){
            if(this.$refs.sliderRail)
                return this.$refs.sliderRail.clientWidth
            return 0
        }
    },
    components: {
        DragHelper
    }
};

</script>

<style lang="stylus">
$slider-height = 20px
$slider-width = 90%
$rail-height = 6px
$knob-size = 35px
$rail-color = #e2e2e2
$rail-fill-color = #21fb92
$knob-color = white
$knob-border = 5px solid #4bc67d
// $knob-shadow = 1px 1px rgba(0, 0, 0, 0.2)
.lgrm-range-slider
  display: inline-block
  padding: 0 $knob-size / 2
  height: $slider-height
  width: $slider-width
  max-width 500px
  margin-bottom: 20px
.lgrm-range-slider.disabled
  opacity: 0.5
.range-slider-inner
  display: inline-block
  position: relative
  height: 100%
  width: 100%
.range-slider-rail,
.range-slider-fill
  display: block
  position: absolute
  top: 50%
  left: 0
  height: $rail-height
  border-radius: ($rail-height / 2)
  transform: translateY(-50%)
.range-slider-rail
  width: 100%
  background: #e6e5ea;
  background-image: linear-gradient(to right, #b94a48 60%, #f1c40f 80%, #4bc67d 100%);
.range-slider-fill
  background-color: $rail-fill-color
.range-slider-knob
  display: block
  position: absolute
  top: 50%
  left: 0
  box-sizing: border-box
  height: $knob-size
  width: $knob-size
  border: $knob-border
  border-radius: 50%
  background-color: $knob-color
  box-shadow: $knob-shadow
  transform: translate(-50%, -50%)
  cursor: pointer
.range-slider-hidden
  display: none
.knob-value
  padding-top: 4px 
  font-weight: 500
  font-size: 14px
</style>
